/**
 * This file gets loaded when we are operating within a "donate" environment.
 * The donate environment comes from coming from the donation flow and transitioning to '/transfer/buy/external/donate',
 * which redirects to the preview page.
 */

import React from 'react'
import { postMessageUp } from 'iframe-support'
import * as fpti from '../../lib/analytics/fpti'
import store from '../stores/configureStore'
import ShareMyAddress from '../components/share-my-address'
import AmountDonationValidationError from '../components/amount-donation-validation-error'
import NoteMaxCharLimitError from '../components/note-max-char-limit-error'
import Separator from '../components/separator'

export default {
  // experimental way to pass in components from hooks
  // TODO: find a way to externalize these components
  // or just bring them into the app fully
  customComponents: [
    {
      page: 'preview',
      position: 'before:userAgreement',
      component: <ShareMyAddress />,
    },
    {
      page: 'send-amount-field',
      position: 'after:firstTimeHelp',
      component: <Separator />,
    },
    {
      page: 'send-amount-field',
      position: 'before:firstTimeHelp',
      component: <AmountDonationValidationError />,
    },
    {
      page: 'note-with-gift',
      position: 'after:note',
      component: <NoteMaxCharLimitError />,
    },
  ],

  // TODO: find a way to externalize this as well
  initializeHook() {
    fpti.overrideEnvironment('donate')
  },

  // DEPRECATED: THESE ARE ONLY USED IN THE LEGACY DONATE IFRAME

  loadingStateChangedHook({ isLoading }) {
    // TODO: update donatenodeweb:p2pframe.js to support true/false
    if (isLoading) {
      postMessageUp({ toggleLoading: isLoading })
    } else {
      // there's no current way to send a "stop loading" message
      postMessageUp({ statusMessage: 'fundingOptionsRendered' })
    }
  },

  sessionTimerOverlayRenderedHook() {
    postMessageUp({ statusMessage: 'sessionTimerOverlayRendered' })
  },

  // see: donatenodeweb:public/js//member/review.js
  showAddNewFIHook() {
    postMessageUp({ statusMessage: 'addNewFIRendered' })
  },

  previewPageAfterRenderHook() {
    postMessageUp({ statusMessage: 'fundingOptionsRendered' })
  },

  previewPageSendSubmitHook(props = {}) {
    let {
      amount = {},
      external = {},
      donate = {},
      transaction = {},
      address: {
        selectedShippingAddress: { id: selectedShippingAddressId },
      },
    } = store.getState() || {}
    let donatedAmount = amount.amount
    let currencyCode = amount.currencyCode
    let giftAidItFlag = external.donationGiftAidCheckbox
    let donationAnonymousStatus = donate.donationAnonymousStatus
    const { cvv, threeDS2ReferenceId, threeDS2TransactionId } = transaction

    const { isRecurring, recipient, selectedFundingOption } = props
    postMessageUp({
      statusMessage: 'previewPageSendAction',
      data: {
        isRecurring,
        recipient,
        selectedFundingOption,
        selectedShippingAddressId,
        giftAidItFlag,
        donatedAmount,
        currencyCode,
        threeDS2ReferenceId,
        threeDS2TransactionId,
        cvv,
        donationAnonymousStatus,
      },
    })
  },

  successPageAfterRenderHook() {
    let {
      paymentDetails = {},
      selectedFundingOption = {},
    } = store.getState().transaction
    let { amount = {}, external = {} } = store.getState() || {}
    let donatedAmount = amount.amount
    let currencyCode = amount.currencyCode
    let giftAidCheckboxFlag = external.donationGiftAidCheckbox

    // TODO: remove to this, after changing donateweb:p2pFrame.js - backward compatible
    postMessageToParent(`successPageRendered:${paymentDetails.payment_id}`)

    postMessageUp({
      statusMessage: 'successPageRendered',
      data: {
        paymentId: paymentDetails.payment_id,
        selectedFundingOption: selectedFundingOption,
        donationGiftaid: giftAidCheckboxFlag,
        donatedAmount: donatedAmount,
        currencyCode: currencyCode,
      },
    })
    // TODO: move to this thing, by changing donateweb:p2pFrame.js
    // postMessageUp({ successPageRendered: paymentDetails.payment_id })
  },

  requestUnifiedLoginHook() {
    postMessageUp({
      statusMessage: 'requestUnifiedLogin',
    })
  },
}

/**
 * Do a post message up to a parent iframe (if it exists)
 * @param msg
 */
// TODO: Need to be removed once listing of post messages is in sync with donatenodeweb (also remove L#119, L#128, L#137, L#146 & L#164)
function postMessageToParent(msg) {
  let parent = (window && window.parent) || {}

  if (parent.postMessage && parent.location) {
    parent.postMessage(msg, '*')
  }
}
